import { ReactNode } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

type TabsPanelTypes = {
  value: string;
  children: ReactNode;
  activeTab: string;
  className?: any;
  renderAllPanels?: boolean;
};

const TabsPanel = ({
  value,
  children,
  className = "",
  activeTab,
  renderAllPanels = false,
}: TabsPanelTypes) => {
  if (!renderAllPanels && value !== activeTab) return null;

  return <div className={className}>{children}</div>;
};

export default wrapperHOC(TabsPanel, {
  componentName: "TabsPanel-Tabs-Global",
  showForChina: true,
});
